module.exports = __webpack_public_path__ + "static/media/Punjab Assembly Hall c. 1940s.7d006491.jpg";